(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shkti-hero"] && !Shopify.designMode) return;
  try {
    
  class ShktiHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.shkti-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
      this.track = this.querySelector('.shkti-hero__track');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => { this.syncVideos(); this.start(); };
      this.reduce.addEventListener('change', this.onMotionChange);
      this.onVisibilityChange = () => {
        this.syncVideos();
        if (document.hidden) this.stop(); else this.start();
      };
      document.addEventListener('visibilitychange', this.onVisibilityChange);
      this.syncVideos();
      if (this.slides.length < 2) return;

      this.index = 0;
      this.count = this.slides.length;
      this.isSlide = this.dataset.transition === 'slide';
      this.speed = parseInt(this.dataset.speed, 10) || 6000;
      this.timer = null;

      const prev = this.querySelector('[data-hero-prev]');
      const next = this.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
      if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.go(parseInt(dot.dataset.heroDot, 10));
          this.restart();
        });
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.bindSwipe();
      this.render();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      this.reduce?.removeEventListener('change', this.onMotionChange);
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      this.querySelectorAll('video').forEach((video) => video.pause());
    }

    syncVideos() {
      this.slides.forEach((slide) => {
        slide.querySelectorAll('video').forEach((video) => {
          video.controls = this.reduce.matches;
          if (this.reduce.matches || document.hidden || !slide.classList.contains('is-active')) video.pause();
          else video.play().catch(() => {});
        });
      });
    }

    go(i) {
      this.index = (i + this.count) % this.count;
      this.render();
    }

    render() {
      const focusInSlide = this.slides.some((slide) => slide.contains(document.activeElement));
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      if (focusInSlide) {
        this.slides[this.index].querySelector('a, button, video[controls]')?.focus({ preventScroll: true });
      }
      this.syncVideos();
      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (this.isSlide && this.track) {
        this.track.style.transform = 'translateX(' + (-this.index * 100) + '%)';
      }
    }

    start() {
      this.stop();
      if (this.slides.length < 2 || this.dataset.autoplay !== 'true' || this.reduce.matches || document.hidden || this.contains(document.activeElement) || this.matches(':hover')) return;
      this.timer = window.setInterval(() => this.go(this.index + 1), this.speed);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.start();
    }

    bindSwipe() {
      let startX = 0;
      let active = false;
      const viewport = this.querySelector('.shkti-hero__viewport');
      if (!viewport) return;
      viewport.addEventListener('pointerdown', (e) => {
        active = true;
        startX = e.clientX;
      });
      viewport.addEventListener('pointerup', (e) => {
        if (!active) return;
        active = false;
        const dx = e.clientX - startX;
        if (Math.abs(dx) < 40) return;
        this.go(dx < 0 ? this.index + 1 : this.index - 1);
        this.restart();
      });
      viewport.addEventListener('pointercancel', () => { active = false; });
    }
  }

  if (!customElements.get('shkti-hero-slider')) {
    customElements.define('shkti-hero-slider', ShktiHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shkti-instagram"] && !Shopify.designMode) return;
  try {
    
  class ShktiMediaMosaic extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.shkti-instagram__lb');
      this.slides = Array.from(this.querySelectorAll('.shkti-instagram__lb-slide'));
      if (!this.dialog || !this.slides.length) return;

      this.index = 0;
      this.count = this.slides.length;

      this.querySelectorAll('[data-mosaic-open]').forEach((btn) => {
        btn.addEventListener('click', () => this.open(parseInt(btn.dataset.mosaicOpen, 10)));
      });

      const closeBtn = this.querySelector('[data-lb-close]');
      const prevBtn = this.querySelector('[data-lb-prev]');
      const nextBtn = this.querySelector('[data-lb-next]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.dialog.close());
      if (prevBtn) prevBtn.addEventListener('click', () => this.show(this.index - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.show(this.index + 1));

      /* Backdrop click closes (click landed on the dialog element itself). */
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.show(this.index - 1);
        else if (e.key === 'ArrowRight') this.show(this.index + 1);
      });
      this.dialog.addEventListener('close', () => this.onClose());

      /* Autoplay-on-hover for tile videos. */
      this.querySelectorAll('.shkti-instagram__tile--video').forEach((tile) => {
        const video = tile.querySelector('video');
        if (!video) return;
        tile.addEventListener('mouseenter', () => { video.play().catch(() => {}); });
        tile.addEventListener('mouseleave', () => { video.pause(); });
      });
    }

    open(i) {
      this.show(i);
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
    }

    show(i) {
      this.index = (i + this.count) % this.count;
      this.slides.forEach((slide, idx) => {
        const active = idx === this.index;
        slide.hidden = !active;
        const video = slide.querySelector('video');
        if (video && !active) video.pause();
      });
    }

    onClose() {
      document.body.style.overflow = '';
      this.slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (video) video.pause();
      });
    }
  }

  if (!customElements.get('shkti-media-mosaic')) {
    customElements.define('shkti-media-mosaic', ShktiMediaMosaic);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shkti-motion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shkti-motion-carousel')) {
    customElements.define('shkti-motion-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const rail = this.querySelector('.shkti-motion__rail');
        const buttons = this.querySelectorAll('.shkti-motion__navigation button');
        const update = () => {
          buttons[0].disabled = rail.scrollLeft <= 1;
          buttons[1].disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
        };
        buttons.forEach((button, index) => button.addEventListener('click', () => {
          const step = rail.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap);
          rail.scrollBy({ left: step * (index ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }));
        rail.addEventListener('scroll', update, { passive: true });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(rail);
        update();
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
